import { render } from "./index.vue?vue&type=template&id=ca6bf748&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=ca6bf748&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-ca6bf748"

export default script